import React, { useEffect, useState } from 'react';
import useMessagerie from '../../hooks/useMessagerie';
import CustomSelect from '../../utils/CustomSelect';
import { capitalizeEach } from '../../utils/Format';

const CreateConversationTab = ({ loggedUser, users, setSelectedTab, fetchConversations }) => {
    const { createConversation } = useMessagerie();

    const [listUsersSelected, setSelectedUsers] = useState([]);
    const [conversationName, setConversationName] = useState('');

    useEffect(() => {
        if (users.length > 0 && loggedUser?.UUID) {
            setSelectedUsers(
                users
                    .filter((u) => u.UUID_ !== loggedUser.UUID)
                    .map((u) => ({
                        UUID_: u.UUID_,
                        Nom: u.Nom,
                        Email: u.Email,
                        selected: false,
                    }))
            );
        }
    }, [users, loggedUser]);

    const resetState = () => {
        setConversationName('');
        setSelectedUsers(
            users.map((u) => ({
                UUID_: u.UUID_,
                Nom: u.Nom,
                Email: u.Email,
                selected: false,
            }))
        );
    };

    const handleUsersSelectionChange = (nom) => {
        setSelectedUsers((prev) =>
            prev.map((user) =>
                user.Nom === nom ? { ...user, selected: !user.selected } : user
            )
        );
    };

    const handleCreateConversation = () => {
        const participants = listUsersSelected
            .filter((u) => u.selected)
            .map((u) => u.UUID_);

        const payload = {
            Participants: JSON.stringify(participants),
            Nom_Conversation: conversationName,
        };

        createConversation(payload)
            .then(() => fetchConversations())
            .then(() => {
                resetState();
                setSelectedTab('listconv');
            })
            .catch((error) => {
                console.error('Erreur lors de la création de la conversation:', error);
                alert('Erreur lors de la création de la conversation. Veuillez réessayer.');
            });
    };

    const handleCancel = () => {
        resetState();
        setSelectedTab('listconv');
    };

    return (
        <div className="flex-shrink-0 w-full h-full">
            <div className="flex justify-center items-center bg-gray-800 mb-4 p-3 rounded-xl">
                <button
                    className="px-3 py-1 rounded-md text-red-700 hover:text-orange-600 text-xs transition"
                    onClick={handleCancel}
                >
                    Annuler
                </button>

                <div className="flex flex-1 justify-center items-center gap-3">
                    <img
                        src="https://cdn-icons-png.flaticon.com/512/149/149071.png"
                        alt=""
                        className="border border-gray-600 rounded-full w-12 h-12 object-cover"
                    />
                    <div>
                        <p className="font-medium text-white">{capitalizeEach(loggedUser.Nom)}</p>
                        <p className="text-green-400 text-xs">En ligne</p>
                    </div>
                </div>

                <button
                    onClick={handleCreateConversation}
                    className="bg-orange-600 hover:bg-orange-500 px-3 py-1 rounded-md font-semibold text-white text-xs transition"
                >
                    Créer une conversation
                </button>
            </div>

            <div className="space-y-5 bg-gray-800 shadow p-6 border border-gray-700 rounded-xl">
                <div>
                    <label className="block mb-1 text-gray-300 text-sm">Nom de la conversation</label>
                    <input
                        type="text"
                        value={conversationName}
                        onChange={(e) => setConversationName(e.target.value)}
                        placeholder="Ex : Équipe projet, SAV Vinci, etc."
                        className="bg-gray-700 px-4 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-600 w-full text-white text-sm placeholder-gray-400"
                    />
                </div>

                <div>
                    <label className="block mb-1 text-gray-300 text-sm">Participants</label>
                    <CustomSelect
                        value={`Utilisateurs sélectionnés (${listUsersSelected.filter((u) => u.selected).length})`}
                        options={listUsersSelected}
                        onChange={handleUsersSelectionChange}
                        multiple={true}
                        className="bg-gray-700 rounded-lg text-gray-300 text-sm hover:placeholder-gray-300 placeholder-gray-500"
                        classNameIn="bg-gray-700 text-gray-300 hover:bg-gray-600"
                    />
                </div>

                <div className="flex justify-end">
                    <button
                        onClick={handleCreateConversation}
                        className="bg-orange-600 hover:bg-orange-500 px-4 py-2 rounded-md text-white text-sm transition"
                    >
                        Créer la conversation
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CreateConversationTab;
